// utils/setCompanyContext.js

/**
 * Define o contexto da empresa no localStorage
 * @param {number} companyId - ID da empresa
 * @param {string} companyName - Nome da empresa
 * @param {string} companySlug - Slug da empresa
 * @param {string} [companyType] - Tipo da empresa (ex.: 'academia', 'isp', 'empresa')
 */
export function setCompanyContext(companyId, companyName, companySlug, companyType) {
  const companyContext = {
    ids: [companyId],
    companies: [{
      id: companyId,
      name: companyName,
      slug: companySlug,
      ...(companyType != null && { type: companyType })
    }]
  };

  localStorage.setItem('horizon_company_context', JSON.stringify(companyContext));

  // Disparar evento para notificar outros componentes
  const event = new CustomEvent('company-context-changed', {
    detail: { companyContext }
  });
  window.dispatchEvent(event);
}

/**
 * Obtém o contexto da empresa do localStorage
 * @returns {Object|null} Contexto da empresa ou null se não encontrado
 */
export function getCompanyContext() {
  try {
    const stored = localStorage.getItem('horizon_company_context');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Erro ao obter contexto da empresa:', error);
  }
  return null;
}

/**
 * Verifica se há contexto de empresa definido
 * @returns {boolean} True se há contexto definido
 */
export function hasCompanyContext() {
  const context = getCompanyContext();
  return context && context.ids && Array.isArray(context.ids) && context.ids.length > 0;
}

/**
 * Define o contexto do grupo consolidado
 * @param {Array} companies - Empresas disponíveis no grupo
 * @param {Array} [selectedCompanies] - Empresas que entram no consolidado
 * @param {Object} [group] - Metadados do grupo
 */
export function setGroupContext(companies, selectedCompanies = companies, group = null) {
  const availableCompanies = Array.isArray(companies) ? companies : [];
  const selected = Array.isArray(selectedCompanies) && selectedCompanies.length > 0
    ? selectedCompanies
    : availableCompanies;
  const companyContext = {
    ids: selected.map(c => c.id),
    companies: selected,
    available_companies: availableCompanies,
    isConsolidated: true,
    isGroup: true,
    group: group || {
      id: 'group',
      name: 'Horizon Group',
      slug: 'horizon-group'
    }
  };
  
  localStorage.setItem('horizon_company_context', JSON.stringify(companyContext));
  
  // Disparar evento para notificar outros componentes
  const event = new CustomEvent('company-context-changed', {
    detail: { companyContext }
  });
  window.dispatchEvent(event);
}

/**
 * Define automaticamente o contexto da empresa baseado no usuário logado
 */
export function setDefaultCompanyContext() {
  // Tentar obter dados do usuário do localStorage
  const savedUser = localStorage.getItem('dashboard_user');
  if (savedUser) {
    try {
      const user = JSON.parse(savedUser);
      if (user.accessible_companies && user.accessible_companies.length > 0) {
        // Usar a primeira empresa acessível
        const firstCompany = user.accessible_companies[0];
        setCompanyContext(firstCompany.id, firstCompany.name, firstCompany.slug, firstCompany.type);
        return;
      }
    } catch (error) {
      console.warn('Erro ao obter dados do usuário:', error);
    }
  }
  
  // Fallback para MOV Fibra se não conseguir obter dados do usuário
  setCompanyContext(1, 'MOV Fibra', 'mov-fibra', 'empresa');
}
